import {PartyType} from '@sollapay/enums';

import type {IconName} from '@sollapay/ui/components';

/** Companies render as a square avatar, individuals (or an unknown/legacy partyType) as a circle. */
export function getPartyAvatarShape(partyType: PartyType | undefined): 'circle' | 'square' {
  return partyType === PartyType.ORGANIZATION ? 'square' : 'circle';
}

/** Companies render with a building glyph, individuals (or an unknown/legacy partyType) with a person glyph. */
export function getPartyTypeIcon(partyType: PartyType | undefined): IconName {
  return partyType === PartyType.ORGANIZATION ? 'building' : 'user';
}
